import axios from "axios";
const CONTROLLER_PATH = "BrokerFirm";
class BrokerFirmService {
    //CREATE
    create(formData) {
        return axios
            .post(CONTROLLER_PATH, formData, {
                headers: {
                    "Content-Type": "multipart/form-data",
                },
            })
            .then((response) => response.data);
    }

    //READ
    get(id, urlParameters, requestId) {
        return axios
            .get(CONTROLLER_PATH + (id ? "/" + id : ""), {
                params: urlParameters,
                requestId: requestId,
            })
            .then((response) => ({
                data: response.data,
                requestId: response.config.requestId,
            }));
    }
    getlist() {
        return axios.get(CONTROLLER_PATH + "/getlist").then((response) => response.data);
    }

    //UPDATE
    update(id, formData) {
        //formData.append('_method', 'PUT');
        return axios
            .put(CONTROLLER_PATH + "/" + id, formData, {
                headers: {
                    "Content-Type": "multipart/form-data",
                },
            })
            .then((response) => response.data);
    }

    //DELETE
    delete(id) {
        return axios.delete(CONTROLLER_PATH + "/" + id).then(() => {});
    }

    // Notes
    getNotes(brokerFirmId) {
        return axios.get(`${CONTROLLER_PATH}/${brokerFirmId}/notes`).then((response) => response.data);
    }

    addNote(brokerFirmId, noteText){
        return axios
            .post(`${CONTROLLER_PATH}/${brokerFirmId}/notes`, JSON.stringify(noteText), {
                headers: {
                    'Content-Type': 'application/json'
                }
            })
            .then((response) => response.data);
    }

    getContacts(brokerFirmId) {
        return axios.get(`${CONTROLLER_PATH}/${brokerFirmId}/contacts`).then((response) => response.data);
    }

    getBrokerFirmContactDesignations(){
        return axios.get(`${CONTROLLER_PATH}/GetBrokerFirmContactDesignations`).then((response) => response.data);
    }

    addBrokerFirmContact(payload){
        return axios
            .post(`${CONTROLLER_PATH}/contacts/create`, payload, {
                headers: {
                    'Content-Type': 'application/json'
                },
            })
            .then((response) => response.data);
    }

    updateBrokerFirmContact(payload){
        return axios
            .put(`${CONTROLLER_PATH}/contacts/update`, payload, {
                headers: {
                    'Content-Type': 'application/json'
                },
            })
            .then((response) => response.data);
    }

    deleteBrokerFirmContact(contactId){
        return axios.delete(`${CONTROLLER_PATH}/contacts/${contactId}`).then((response) => response.data);
    }

    getBrokerFirmStatuses(){
        return axios.get(`${CONTROLLER_PATH}/GetBrokerFirmStatuses`).then((response) => response.data);
    }

}

export default new BrokerFirmService();
